<div>
    <br />
    <div ng-form="userForm">
        <div class="row invoice-detail">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <h4>User Orders</h4>

                        <p>These are the orders associated with your invoice.</p>

                        <table class="table">
                            <thead>
                                <tr>
                                    <th
                                        class="text-center"
                                        width="120"
                                    >Order Date</th>
                                    <th>Order Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    class="my-product-item-tr"
                                    *ngFor="let userOrder of userOrders"
                                >
                                    <td class="date-created">
                                        <div>{{userOrder.dateCreatedUtc | date: "MMM dd, yyyy"}}</div>
                                    </td>
                                    <td>
                                        <div class="row invoice-detail">
                                            <div class="invoice-download-link">
                                                <a [routerLink]="['/account/order-details', userOrder.id]">{{userOrder.orderNumber}}</a>
                                            </div>
                                            <div *ngIf="userOrder.numberOfRefundedItems > 0 && userOrder.totalRefundAmount > 0">
                                                <small class="refunded-items">{{userOrder.numberOfRefundedItems}} item(s) refunded for {{userOrder.totalRefundAmount | currency : userOrder.currencyCode: userOrder.currencyCode + " "}}</small>
                                            </div>
                                            <div>
                                                <small>Amount: {{userOrder.total | currency : userOrder.currencyCode: userOrder.currencyCode + " "}}</small>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
